function SampleReportsController($scope) {}

function SvgPath() {
    this.parts = [];
}
SvgPath.prototype.M = function(x, y) { this.parts.push('M ' + x + ' ' + y); return this; };
SvgPath.prototype.m = function(dx, dy) { this.parts.push('l ' + dx + ' ' + dy); return this; };
SvgPath.prototype.L = function(x, y) { this.parts.push('L ' + x + ' ' + y); return this; };
SvgPath.prototype.H = function(x) { this.parts.push('H ' + x); return this; };
SvgPath.prototype.V = function(y) { this.parts.push('V ' + y); return this; };
SvgPath.prototype.l = function(dx, dy) { this.parts.push('l ' + dx + ' ' + dy); return this; };
SvgPath.prototype.h = function(dx) { this.parts.push('h ' + dx); return this; };
SvgPath.prototype.v = function(dy) { this.parts.push('v ' + dy); return this; };
SvgPath.prototype.Z = function() { this.parts.push('Z'); return this; };
SvgPath.prototype.C = function(x1, y1, x2, y2, x, y) { this.parts.push('C '+x1+' '+y1+', '+x2+' '+y2+', '+x+' '+y); return this; };
SvgPath.prototype.c = function(dx1, dy1, dx2, dy2, dx, dy) { this.parts.push('c '+dx1+' '+dy1+', '+dx2+' '+dy2+', '+dx+' '+dy); return this; };
SvgPath.prototype.S = function(x2, y2, x, y) { this.parts.push('S '+x2+' '+y2+', '+x+' '+y); return this; };
SvgPath.prototype.s = function(dx2, dy2, dx, dy) { this.parts.push('s '+dx2+' '+dy2+', '+dx+' '+dy); return this; };
SvgPath.prototype.Q = function(x1, y1, x, y) { this.parts.push('Q '+x1+' '+y1+', '+x+' '+y); return this; };
SvgPath.prototype.q = function(dx1, dy1, dx, dy) { this.parts.push('q '+dx1+' '+dy1+', '+dx+' '+dy); return this; };
SvgPath.prototype.T = function(x, y) { this.parts.push('T '+x+' '+y); return this; };
SvgPath.prototype.t = function(dx, dy) { this.parts.push('t '+dx+' '+dy); return this; };
SvgPath.prototype.toString = function() { return this.parts.join(' '); };


function ReportTabsController($scope, $element) {
    $element.appendTo($('#content'));

    var tabs = [];
    var activeTab = 0;

    window.addEventListener('resize', function () {
        draw(activeTab);
    });

    $scope.$on('reportTab:ready', function(e, $elm, title, hash, $img, $content) {
        tabs.push({
            $elm: $elm,
            title: title,
            hash: hash,
            $img: $img,
            $content: $content
        });

        if (location.hash === '#' + hash) activeTab = tabs.length - 1;

        if (tabs.length === 5 &&
            (location.hash === '#development-report' ||
                location.hash === '#leadership-report' ||
                location.hash === '#sales-report' ||
                location.hash === '#coaching-report' ||
                location.hash === '#customized-report')) {
            setTimeout(function() {
                var $rt = $('report-tabs');
                var offset = $rt.offset();
                // console.log('Ready!', !!location.hash, offset);

                $('html, body').stop().animate({
                    scrollTop: offset.top - 100
                }, 100, 'swing');
            }, 1);
        }
        draw(activeTab);
    });

    var empty = function(elm) {
        while (elm.firstChild) elm.firstChild.remove();
    };
    var getNode = function(n, v) {
        n = document.createElementNS('http://www.w3.org/2000/svg', n);
        for (var p in v)
            n.setAttributeNS(null, p.replace(/[A-Z]/g, function(m, p, o, s) { return "-" + m.toLowerCase(); }), v[p]);
        return n
    };
    var setContent = function(activeTab) {
        // Position to tab content
        var $tabContent = $('#tab-content');
        $tabContent.html('');
        tabs[activeTab].$content.appendTo($tabContent);
    };
    var draw = function(aActiveTab) {
        activeTab = aActiveTab;
        setContent(activeTab);
        setTimeout(function() { drawTabs(activeTab); }, 1);
    };
    var drawTabs = function(activeTab) {
        var svg = document.getElementById('report-tabs-svg');
        empty(svg);
        if (tabs.length <= 0) return;

        var w = svg.clientWidth-1;

        var offset = 20;
        var tabArea = w - (offset * 2);

        // console.log('w', w, 'h', h);
        var tabCount = tabs.length;

        var borderRadius = 20;
        var tabGutter = 30;

        var tabAreaWidth = tabArea / tabCount;
        var tabWidth = tabAreaWidth - tabGutter;
        var tabHeight = 50;
        var activeTabEx = 20;
        var activeTabHeight = tabHeight + activeTabEx;

        var imageSize = Math.min(tabWidth, 120);
        var frameTop = imageSize + 20;

        var $tabContent = $('#tab-content');
        var h = $tabContent.innerHeight() + frameTop + 50;
        svg.style.height = h;

        $tabContent.css('top', frameTop + activeTabHeight);

        for (var i=0; i<tabCount; i++) {
            var left = offset + (tabAreaWidth * i);
            left += tabGutter / 2;

            var img = getNode('svg', {x: left + (tabWidth / 2 - imageSize / 2), y: 0, width: imageSize, height: imageSize});
            img.innerHTML = tabs[i].$img.first('svg').html();
            // if (activeTab === i) img.classList.add('with-drop-shadow');
            svg.appendChild(img);

            if (i === activeTab) {
                var path = new SvgPath();
                path
                    // Start, tab top left
                    .M(left + borderRadius, frameTop)
                    // Tab top H
                    .h(tabWidth - (borderRadius * 2))
                    // Tab top right curve
                    .q(borderRadius, 0, borderRadius, borderRadius)
                    // Tab right V
                    .v(activeTabHeight - (borderRadius * 2))
                    // Tab bottom right curve
                    .q(0, borderRadius, borderRadius, borderRadius)
                    // Content top H
                    .H(w - borderRadius)
                    // Content top right curve
                    .q(borderRadius, 0, borderRadius, borderRadius)
                    // Content right V
                    .V(h - borderRadius)
                    // Content bottom right curve
                    .q(0, borderRadius, -borderRadius, borderRadius)
                    // Content bottom H
                    .H(borderRadius)
                    // Content bottom left curve
                    .q(-borderRadius, 0, -borderRadius, -borderRadius)
                    // Content left V
                    .V(frameTop + activeTabHeight + borderRadius)
                    // Content top left curve
                    .q(0, -borderRadius, borderRadius, -borderRadius)
                    // Content top H
                    .H(left -borderRadius)
                    // Tab bottom left curve
                    .q(borderRadius, 0, borderRadius, -borderRadius)
                    // Tab left V
                    .v(-(activeTabHeight - (borderRadius * 2)))
                    // Tab top left curve
                    .q(0, -borderRadius, borderRadius, -borderRadius);

                // console.log(path.toString());

                var g = getNode('g', { class: 'tab active' });
                svg.appendChild(g);

                var n = getNode('path', { d: path.toString(), stroke: '#ccc', 'stroke-width': 2, fill: 'white'});
                g.appendChild(n);


                if (tabWidth < 180) {
                    var parts = tabs[i].title.split(' ');
                    var top = frameTop + 30;
                    for (var j=0; j<parts.length; j++) {
                        n = getNode('text', { 'pointer-events': 'none', 'text-anchor': 'middle', x: left + (tabWidth / 2), y: top });
                        n.textContent = parts[j];
                        g.appendChild(n);
                        top += 25;
                    }
                }
                else {
                    n = getNode('text', { 'pointer-events': 'none', 'text-anchor': 'middle', x: left + (tabWidth / 2), y: frameTop + 35 });
                    n.textContent = tabs[i].title;
                    g.appendChild(n);
                }


            }
            else {
                var path = new SvgPath();
                path
                    // Start, left bottom
                    .M(left, frameTop + activeTabHeight)
                    // Tab left V
                    .v(-(activeTabHeight - activeTabEx - borderRadius))
                    // Tab top left curve
                    .q(0, -borderRadius, borderRadius, -borderRadius)
                    // Tab top H
                    .h(tabWidth - (borderRadius * 2))
                    // Tab top right curve
                    .q(borderRadius, 0, borderRadius, borderRadius)
                    .v(activeTabHeight - activeTabEx - borderRadius)
                    .Z();

                var g = getNode('g', { class: 'tab' });
                svg.appendChild(g);

                var n = getNode('path', { 'data-tab': i, d: path.toString(), stroke: '#ccc', 'stroke-width': 2, fill: '#c1c1c1'});
                n.addEventListener('click', function(e) {
                    var activeIdx = parseInt(e.target.dataset.tab);
                    location.hash = tabs[activeIdx].hash;
                    draw(activeIdx);
                });
                g.appendChild(n);

                if (tabWidth < 180) {
                    var parts = tabs[i].title.split(' ');
                    var top = frameTop + activeTabEx + 23;
                    for (var j=0; j<parts.length; j++) {
                        n = getNode('text', { 'pointer-events': 'none', 'text-anchor': 'middle', x: left + (tabWidth / 2), y: top });
                        n.textContent = parts[j];
                        g.appendChild(n);
                        top += 20;
                    }
                }
                else {
                    n = getNode('text', { 'pointer-events': 'none', 'text-anchor': 'middle', x: left + (tabWidth / 2), y: frameTop + activeTabEx + 35 });
                    n.textContent = tabs[i].title;
                    g.appendChild(n);
                }
            }
        }
    };
}
function ReportTabController($scope, $element) {
    this.$postLink = function() {
        setTimeout(function() {
            // Can the image and remove from parent
            var $img = $element.find('svg').parent();
            $img.remove();

            var title = $element.prop('title');
            var hash = title.toLowerCase().replace(/ /g, '-');

            $scope.$emit('reportTab:ready', $element, title, hash, $img, $('div[ng-transclude]', $element));
        }, 500);
    };
}

function DownloadAllController($scope, $element) {
    $element.hide();
    setTimeout(function() {
        $element.appendTo($('#content')).show();
    }, 100);

}
function PricingController($scope, $element) {
    $element.hide();
    setTimeout(function() {
        $element.appendTo($('#content')).show();
    }, 200);
}

angular.module('app')
    .component('sampleReports', {
        transclude: true,
        controller: ['$scope', SampleReportsController],
        templateUrl: '/assets/built/app/components/reports/sampleReports.html'
    })
    .component('reportTabs', {
        transclude: true,
        controller: ['$scope', '$element', ReportTabsController],
        templateUrl: '/assets/built/app/components/reports/reportTabs.html'
    })
    .component('reportTab', {
        transclude: true,
        controller: ['$scope', '$element', ReportTabController],
        templateUrl: '/assets/built/app/components/reports/reportTab.html'
    })
    .component('downloadAll', {
        transclude: true,
        controller: ['$scope', '$element', DownloadAllController],
        templateUrl: '/assets/built/app/components/reports/downloadAll.html'
    })
    .component('pricing', {
        transclude: true,
        controller: ['$scope', '$element', PricingController],
        templateUrl: '/assets/built/app/components/reports/pricing.html'
    });
